import apiClient from './client'
import type { Attendance, MarkAttendanceRequest, AttendanceStats } from '@shared/types/api'

export const attendanceApi = {
  // POST /api/v1/attendance - отметить посещаемость
  mark: async (data: MarkAttendanceRequest): Promise<Attendance> => {
    const response = await apiClient.post<Attendance>('/attendance', data)
    return response.data
  },

  // GET /api/v1/groups/{groupId}/attendance?date={date} - получить посещаемость группы за день
  getByGroupAndDate: async (groupId: string, date: string): Promise<Attendance[]> => {
    const response = await apiClient.get<Attendance[]>(`/groups/${groupId}/attendance`, {
      params: { date },
    })
    return response.data
  },

  // GET /api/v1/athletes/{athleteId}/attendance?from={from}&to={to} - история посещаемости спортсмена
  getByAthleteAndDateRange: async (
    athleteId: string,
    from: string,
    to: string
  ): Promise<Attendance[]> => {
    const response = await apiClient.get<Attendance[]>(`/athletes/${athleteId}/attendance`, {
      params: { from, to },
    })
    return response.data
  },

  // GET /api/v1/athletes/{athleteId}/attendance/stats?from={from}&to={to} - статистика посещаемости
  getStats: async (athleteId: string, from: string, to: string): Promise<AttendanceStats> => {
    const response = await apiClient.get<AttendanceStats>(
      `/athletes/${athleteId}/attendance/stats`,
      {
        params: { from, to },
      }
    )
    return response.data
  },

  // PUT /api/v1/attendance/{id} - обновить запись о посещаемости
  update: async (id: string, data: Partial<Attendance>): Promise<Attendance> => {
    const response = await apiClient.put<Attendance>(`/attendance/${id}`, data)
    return response.data
  },

  // DELETE /api/v1/attendance/{id} - удалить запись
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/attendance/${id}`)
  },
}
